export interface AuthState {
  userAuthenticated: boolean
  bearerToken: string
}

export const initialAuthState: AuthState = {
  userAuthenticated: false,
  bearerToken: undefined
}
